module.exports = __webpack_public_path__ + "static/img/promotion_default.fbbe6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion_default.png
// module id = nIcM
// module chunks = 1